import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const manufacturingV2Api = axios.create({
  baseURL: config.manufacturingV1ApiBaseUrl,
  params: {
    apikey: config.apiKey,
  },
});

const createManufacturingV1Api = createApi(manufacturingV2Api);
export const getManufacturingV1Data = createManufacturingV1Api('get');
export const patchManufacturingV1Data = createManufacturingV1Api('patch');
export const postManufacturingV1Data = createManufacturingV1Api('post');
export const putManufacturingV1Data = createManufacturingV1Api('put');